/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览
 */

import React, { PureComponent } from 'react';
import cns from 'classnames';
import { Tabs } from 'antd';
import GroupBox from '../../common/groupBox/GroupBox';
import Trends from './riskHint/Trends';
import Announcement from './riskHint/Announcement';

const TabPane = Tabs.TabPane;

export default class RiskHint extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { options } = this.props;
        return (
            <div className="base-panel">
                <GroupBox
                    title="公司风险动态提示"
                >
                    <Tabs defaultActiveKey="trends" animated={false} className={cns('line-tabs margin')} >
                        <TabPane tab="最新动态" key="trends">
                            <Trends options={options} />
                        </TabPane>
                        <TabPane tab="最新公告" key="announcement">
                            <Announcement options={options} />
                        </TabPane>
                    </Tabs>

                </GroupBox>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/RiskHint.jsx